import { usePagination } from '@/hooks';
import { useEffect } from 'react';
import { useQueryParams } from '@/hooks';

const useCommercesPagination = () => {
  const { setQueryParams, getQueryParam } = useQueryParams();
  const { currentPage, pageSize, handlePageChange, handlePageSizeChange } =
    usePagination({
      initialPage: Number(getQueryParam('page')) || 1,
      initialPageSize: Number(getQueryParam('pageSize')) || 10,
    });

  useEffect(() => {
    setQueryParams({ page: String(currentPage), pageSize: String(pageSize) });
  }, [currentPage, pageSize]);

  return { currentPage, pageSize, handlePageChange, handlePageSizeChange };
};

export default useCommercesPagination;
